import { RxCustomerAPI } from '@drifthq/dapper'

export const fetchCalendarStatus = () => {
  return RxCustomerAPI.get('/scheduling/settings/status')
    .checkStatus()
    .retryWithBackoff()
    .map(({ response }) => {
      return {
        connected: response.connected,
        calendar: response.calendar,
        googleAuthed: response.googleAuthed,
        microsoftAuthed: response.microsoftAuthed,
      }
    })
}

export const fetchGoogleCalendars = () => {
  return RxCustomerAPI.get('/google/calendar/calendars')
    .checkStatus()
    .retryWithBackoff()
    .map(({ response }) => {
      return response
    })
}

export const updateGoogleCalendar = calendar => {
  return RxCustomerAPI.post('/google/calendar/calendars/choose', calendar).checkStatus()
}

export const fetchMicrosoftCalendars = () => {
  return RxCustomerAPI.get('/microsoft/calendar/calendars')
    .checkStatus()
    .retryWithBackoff()
    .map(({ response }) => {
      return response
    })
}

export const updateMicrosoftCalendar = calendar => {
  return RxCustomerAPI.post('/microsoft/calendar/calendars/choose', calendar).checkStatus()
}

export const fetchDefaultMeetingSettings = () => {
  return RxCustomerAPI.get('/scheduling/settings')
    .checkStatus()
    .retryWithBackoff()
    .map(({ response }) => response)
}

export const updateDefaultMeetingSettings = (newDefault) => {
  return RxCustomerAPI.put(
    `/scheduling/settings`,
    {
      allowNewAppointments: newDefault.allowNewAppointments,
      allowMeetingManagement: newDefault.allowMeetingManagement,
      bufferTime: newDefault.bufferTime,
      minimumNoticeTime: newDefault.minimumNoticeTime,
      timezone: newDefault.timezone,
      availability: newDefault.availability.map(slot => {
        return {
          dayOfWeek: slot.dayOfWeek,
          startTimeHour: slot.startTime.hour,
          startTimeMinutes: slot.startTime.minutes,
          endTimeHour: slot.endTime.hour,
          endTimeMinutes: slot.endTime.minutes,
        }
      }),
      meetingTemplate: {
        duration: newDefault.duration,
        name: newDefault.name,
        location: newDefault.location,
        inviteDescription: newDefault.inviteDescription,
      },
    }
  )
}
export const updateMeetingSettings = () => {
  return RxCustomerAPI.post('/scheduling/settings', { allowMeetingManagement: true }).checkStatus()
}



// WEBPACK FOOTER //
// ./src/modules/meetings/api.js